module.exports = __webpack_public_path__ + "img/Pitcairn-Islands.06ac96dc.png";